import {
  getViewedListingsClient,
  makeOptionallyAuthenticatedQuery,
} from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'

export const getViewedListingIds = async (
  accessToken: string | null,
  personId: string
): Promise<string[]> => {
  if (!personId) return []

  const { data } = await getViewedListingsClient().getViewedListings(
    { personId, limit: 13 }, // 12 max to display + 1 buffer so the LDP can exclude the current listing and still fill the carousel
    buildAxiosRequestConfig({ accessToken })
  )

  return data.viewedListings.map((v) => v.listingId)
}

export const viewedListingsQuery = makeOptionallyAuthenticatedQuery<
  [string],
  string[]
>('viewed-listings', getViewedListingIds)
